import { getMoment } from 'utils/dateTime.js'
import { convertConstraints } from 'common/utils/constraints'

export const isLimitedConstraint = ({ total }) => total < 1000000

export const isShowDanger = viewsConstraints => viewsConstraints.total - viewsConstraints.value <= 0

export const getViewConstraints = subscription => {
    const constraints = convertConstraints(subscription.constraints)
    const nextRenewalDate = subscription.constraintNextRenewalDate
    const subscriptionViewsCount = constraints.reviewsCount.featureProduct.productOptionValue
    const currentViewsCount = constraints.reviewsCount.currentValue

    return {
        start: getMoment(nextRenewalDate).subtract(1, 'M'),
        end: nextRenewalDate,
        value: subscriptionViewsCount - currentViewsCount,
        total: subscriptionViewsCount,
    }
}
